import React from 'react';
import { NavLink } from 'react-router-dom';

const Navigation = () => (

  <nav className="main-nav">
    <NavLink 
      className="nav-item" 
      to="/gallery">
        <div>
          <p>Gallery</p>
        </div>
    </NavLink>
    
    <NavLink 
      className="nav-item" 
      to="/services">
        <div>
          <p>Services</p>
        </div>
    </NavLink>
    <NavLink 
      className="nav-item" 
      to="/contact">
      <div>
        <p>Contact</p>
      </div>
    </NavLink>
    <NavLink 
      className="nav-item" 
      exact to="/">
        <div>
          <p>Home</p>
        </div>
    </NavLink>
  </nav>
);

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js